import { useMutation, useQuery, useQueryClient } from 'react-query';
import deviceBlocklistService, {
  BlockDeviceBody,
  BlocklistRow,
  DeviceFingerprintRow,
  DeviceLookupParams,
} from '../services/deviceBlocklist.service';

export type { BlockDeviceBody, BlocklistRow, DeviceFingerprintRow, DeviceLookupParams };

const BLOCKLIST_QUERY_KEY = ['device-blocklist'] as const;
const FINGERPRINTS_QUERY_KEY = 'device-fingerprints';

export const useDeviceBlocklist = (enabled = true) =>
  useQuery<{ items: BlocklistRow[] }>(
    BLOCKLIST_QUERY_KEY,
    () => deviceBlocklistService.listBlocklist(),
    { refetchOnWindowFocus: false, enabled }
  );

export const useDeviceFingerprintLookup = (params: DeviceLookupParams, enabled: boolean) =>
  useQuery<{ items: DeviceFingerprintRow[] }>(
    [FINGERPRINTS_QUERY_KEY, params],
    () => deviceBlocklistService.lookup(params),
    { refetchOnWindowFocus: false, enabled, keepPreviousData: true }
  );

export const useBlockDevice = () => {
  const queryClient = useQueryClient();

  return useMutation<{ visitorId: string; blocked: boolean }, unknown, BlockDeviceBody>(
    body => deviceBlocklistService.block(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(BLOCKLIST_QUERY_KEY);
        queryClient.invalidateQueries([FINGERPRINTS_QUERY_KEY]);
      },
    }
  );
};

export const useUnblockDevice = () => {
  const queryClient = useQueryClient();

  return useMutation<{ visitorId: string; blocked: boolean }, unknown, string>(
    visitorId => deviceBlocklistService.unblock(visitorId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(BLOCKLIST_QUERY_KEY);
        queryClient.invalidateQueries([FINGERPRINTS_QUERY_KEY]);
      },
    }
  );
};
